import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';
import { PDFDocument, rgb } from 'pdf-lib';
import axios from 'axios';

@Component({
  selector: 'app-file-finance',
  templateUrl: './file-finance.component.html',
  styleUrls: ['./file-finance.component.css']
})
export class FileFinanceComponent implements OnInit {

  constructor(private http: HttpClient, private storage: AngularFireStorage, private auth: Authenticationservice, private spinner: NgxSpinnerService) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.userlv = userdata.userlevel
    console.log('userdata: ', userdata);
    if (userdata.userlevel == '7' || userdata.userlevel == '9' || userdata.userlevel == '10') {
      this.editer = true
    } else this.editer = false;

  }
  editer: boolean;
  zone = '';
  supcode = '';
  userlv = '';
  sYear = [];
  yearid = "";
  yearTh = "";
  yearidLb = "";
  yearLblast = "";
  yearLst = "";
  yearLft = "";

  fmcode = '';
  url_load = '';
  isUploading = false;

  listYear = [
    ['2425', '6768', '2567/2568', '67/68', '67'],
    ['2526', '6869', '2568/2569', '68/69', '68'],
  ];

  ngOnInit() {
    console.log('userlv:', this.userlv)
    this.sYear = this.listYear[1];
    this.selectYear();
  }

  text_f = '';
  selectYear() {
    let ar = this.sYear;
    this.yearid = ar[0];
    this.yearidLb = ar[1];
    this.yearTh = ar[2];
    this.yearLblast = ar[3];
    this.yearLft = ar[4];
    console.log('sYear:', this.sYear);
    this.LoadDataLists();
  }
  DataList = [];
  LoadDataLists() {
    this.DataList = [];
    this.spinner.show();
    let year = this.yearidLb
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_fileUpload]&w=[fileType]='02'and year='${year}'`;
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length >= 1) {
        data.sort(function (a: any, b: any) { return b.id - a.id });
        this.DataList = data;
      }
    }).catch(err => { throw (err) })
  }

  files_d = [];

  maxSize = 30 * 1024 * 1024; // 10 MB (adjust as needed)
  onFileSelected(event: any) {
    var files = event.target.files[0];
    console.log(files);
    this.files_d = files;

    if (this.yearLft.length == 0) {
      alert('กรุณาเลือกปี ');
      this.url_load = '';
    }
    /*else if (files.type != 'application/pdf') {
      alert('กรุณาเลือกไฟล์ที่เป็น PDF เท่านั้น');
      this.url_load = '';
    }*/
    else if (files.size > this.maxSize) {
      alert('ไฟล์ที่จะอัพโหลด ขนาดไฟล์ต้องไม่เกิน 30 MB');
      this.url_load = '';
    }
    else {
      const file = files[0]; // get single file      
      const Date_dt = new Date();
      const timestamp = Date_dt.getTime();
      const name = files.name;
      console.log('timestamp:', timestamp);

      const path = `brr_smartfarm/draw_money/FileFinance//${this.yearLft}_${name}`;
      const ref = this.storage.ref(path);
      const task = this.storage.upload(path, files);
      // เริ่มอัพโหลด ให้กำหนด isUploading เป็น true
      this.isUploading = true;

      this.storage
        .upload(path, file)
        .percentageChanges();
      task
        .snapshotChanges()
        .pipe(
          finalize(() => {
            ref
              .getDownloadURL()
              .toPromise()
              .then((url) => {
                // const photo: Photo = { url };
                //this.url_load = url;
                console.log('url:', url);
                let newUrl = url.split('&token')[0];
                //console.log('newUrl:', newUrl);
                this.url_load = newUrl;

                // this.urlimg = = url;
                // this.firestore.collection('photos').doc(this.truckq).set(photo);
                // เมื่ออัพโหลดเสร็จสิ้นหรือเกิดข้อผิดพลาด ให้กำหนด isUploading เป็น false
                this.isUploading = false;
              });
          })
        ).subscribe();
    }

  }

  doc = '';
  insert_to() {
    let year = this.yearidLb
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_fileUpload?[year]=" + year + "&[fileType]=02&[doc]=" + this.doc + "&[userAdd]=" + this.supcode + "&[link]=" + this.url_load;
    //console.log('test_url_insert:', url);
    if (confirm("ต้องการบันทึกข้อมูล สำหรับ ")) {
      axios.get(url).then(res => {
        if (res.data.rowsAffected[0] >= 1) {
          alert("บันทึกข้อมูลสำเร็จ ");
          this.LoadDataLists();
          setTimeout(() => {
            this.url_load = '';
            this.doc = '';
          }, 100);
        }
      }).catch(err => { throw (err) })
    }
  }

  cancel_to(data) {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbo].[fileUpload]&s=[status]='0'&w=id='${data.id}'`;
    //console.log('test_url_cancel:', url);
    if (confirm("ต้องการ ยกเลิกข้อมูล " + data.doc + " หรือไม่")) {
      axios.get(url).then(res => {
        this.spinner.hide();
        if (res.data.rowsAffected[0] >= 1) {
          alert(" ยกเลิกข้อมูลสำเร็จ ");
          this.LoadDataLists();
        }
        else {
          alert("ไม่สามารถยกเลิกได้");
        }
      }).catch(err => { throw (err) })
    }
  }

  THtoLocal(thisdate: string) {
    if (!thisdate) { return ''; }
    const date1 = new Date(thisdate);
    let options: any = {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: 'UTC',
    };
    return date1.toLocaleString('th-TH', options);
  }
}